import { Injectable } from '@angular/core';
import { LoginModal } from '../modals/login-modal';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/core/service/api.service';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
import { RegisterModal } from '../modals/register-modal';
import { VerfiyModal } from '../modals/verfiy-modal';
import { SendOtpModal } from '../modals/send-otp-modal';
import { ResetPassModal } from '../modals/reset-pass-modal';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ApiAuthService {

  // public currentUserSubject: BehaviorSubject<any>;
  // public currentUser: Observable<any>;

  constructor(private apiService: ApiService,private router: Router) {
    // this.currentUserSubject = new BehaviorSubject<any>(
    //   JSON.parse(localStorage.getItem('auth')!)
    // );

    // this.currentUser = this.currentUserSubject.asObservable();
    // window.addEventListener(
    //   'storage',
    //   () => {
    //      let userStorage: any = localStorage.getItem('auth');
    //     const userToken = JSON.parse(userStorage);
    //      if (
    //       (this.currentUserValue && localStorage.getItem('auth') && this.currentUserValue.token !== userToken.token) ||
    //       (this.currentUserValue && !localStorage.getItem('auth')) ||
    //       (!this.currentUserValue && localStorage.getItem('auth'))
    //     ) {
    //       this.router.navigate(['/']);
    //       window.location.reload();
    //     }
    //   },
    //   false
    // );
  }


  // public get currentUserValue(): any {
  //   return this.currentUserSubject.value;
  // }

  login(modal: LoginModal) {
    return this.apiService
      .post(`${environment.apiUrl}login`, modal)
      .pipe(catchError(this.handleError));
  }


  register(modal: RegisterModal) {
    return this.apiService
      .post(`${environment.apiUrl}register`, modal)
      .pipe(catchError(this.handleError));
  }
  verfiy(modal: VerfiyModal) {
    return this.apiService
      .post(`${environment.apiUrl}verify-account`, modal)
      .pipe(catchError(this.handleError));
  }
  checkotp(modal: VerfiyModal) {
    return this.apiService
      .post(`${environment.apiUrl}check-otp`, modal)
      .pipe(catchError(this.handleError));
  }
  resetPass(modal: ResetPassModal) {
    return this.apiService
      .post(`${environment.apiUrl}reset-password`, modal)
      .pipe(catchError(this.handleError));
  }
  sendOtp(modal: SendOtpModal) {
    return this.apiService
      .post(`${environment.apiUrl}forget-password`, modal)
      .pipe(catchError(this.handleError));
  }
  GetAllCountries() {
    return this.apiService
      .get(`${environment.apiUrl}countries`)
      .pipe(catchError(this.handleError));
  }
  GetAllRegions(countyId: string) {
    return this.apiService
      .get(`${environment.apiUrl}regions/${countyId}`)
      .pipe(catchError(this.handleError));
  }

  VerifyStaffAccount(token: string, modal: any) {
    return this.apiService
      .post(`${environment.apiUrl}set-password/${token}`, modal)
      .pipe(catchError(this.handleError));
  }
  handleError(error: any) {
    return throwError(error);
  }
}
